import {useState} from "react";
import {Button} from "@sakura-grp/ui/button";
import {SpinningIcon} from "@sakura-grp/ui/spinning-icon";
import {Loader2} from "lucide-react";
import {getClient} from "@sakura-grp/database";
import {toast} from "@sakura-grp/ui/sonner";
import {getAuthErrorMessage} from "@sakura-grp/ui/lib/error-messages";

const supabase = getClient();

export default function GoogleLogin() {
  const [loading, setLoading] = useState(false);
  const handleLogin = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setLoading(true);
    console.log("Googleログイン開始");
    try {
      console.log("GoogleOAuth設定:", {
        provider: "google",
        note: "Supabaseデフォルトリダイレクトを使用（認証元ページに戻る）",
      });
      const {data, error} = await supabase.auth.signInWithOAuth({
        provider: "google",
        options: {
          // 現在のアプリのorigin直下（ルート）に戻る。末尾スラッシュ必須:
          // GoTrue の許可リスト `${origin}/**` は `/**` の前にリテラル `/` を要求するため、
          // bare origin だとマッチせず site_url（ローカルでは admin）へフォールバックしてしまう。
          redirectTo: `${window.location.origin}/`,
          queryParams: {
            access_type: "offline",
            prompt: "consent",
          },
        },
      });
      console.log("GoogleOAuth実行結果:", {
        data: data,
        error: error,
        hasError: !!error,
      });
      if (error) {
        console.error("GoogleOAuthエラー詳細:", {
          error: error,
          message: error?.message,
          status: error?.status,
          code: error?.code,
          name: error?.name,
          stack: error?.stack,
        });
        toast.error("Googleログインに失敗しました", {
          description: getAuthErrorMessage(error),
          duration: 5000,
        });
        setLoading(false);
      }
      // 成功時はSupabaseがGoogle認証画面にリダイレクトするため、
      // setLoading(false)は呼ばない
    } catch (e: any) {
      console.error("Google認証例外エラー詳細:", {
        error: e,
        message: e?.message,
        stack: e?.stack,
        name: e?.name,
        type: typeof e,
        stringified: JSON.stringify(e, null, 2),
      });
      toast.error("Googleログインに失敗しました", {
        description: getAuthErrorMessage(e),
        duration: 5000,
      });
      setLoading(false);
    }
  };

  return (
    <>
      <Button onClick={handleLogin} variant="outline" className="w-full" disabled={loading}>
        {loading ? (
          <SpinningIcon icon={Loader2} size="sm" />
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
            <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" fill="currentColor" />
          </svg>
        )}
        {loading ? "ログイン中..." : "Googleでログイン"}
      </Button>
    </>
  );
}
